// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { SkeletonTheme } from 'react-loading-skeleton';

// Context Providers
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { SocketProvider } from './context/SocketContext';
import { SyncDataProvider } from './context/SyncDataContext';

// Router
import AppRouter from './router/AppRouter';

// Components
import ServerHealthMonitor from './components/common/ServerHealthMonitor';
import { useTheme } from './context/ThemeContext';

// CSS imports
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/theme.css';
import './styles/App.css';

// Inner component that consumes ThemeContext (must be inside ThemeProvider)
function AppShell() {
  const { isDarkMode } = useTheme();
  const skeletonBaseColor = isDarkMode ? "#202020" : "#f0f0f0";
  const skeletonHighlightColor = isDarkMode ? "#444" : "#fafafa";

  return (
    <SkeletonTheme baseColor={skeletonBaseColor} highlightColor={skeletonHighlightColor}>
      <SocketProvider>
        <SyncDataProvider>
          <AppRouter />
          <ServerHealthMonitor />
        </SyncDataProvider>
      </SocketProvider>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        toastClassName="toast-custom"
      />
    </SkeletonTheme>
  );
}

// Main App Container Component - handles theme, loading theme, and routing
function AppContainer() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router basename="">
          <AppShell />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default AppContainer;